import { createAndSendTinyAuthenticatedUrlCommand } from '@/api/Notification/createAndSendTinyAuthenticatedUrlCommand';
import { createTinyAuthenticatedUrlCommand } from '@/api/Notification/owners/createTinyAuthenticatedUrlCommand';

export const NotificationService = {
  createTinyAuthenticatedUrlCommand,
  createAndSendTinyAuthenticatedUrlCommand,
};
